import { type APIRequestBody, post } from './base-fetch';

type AskXInquiryPayload = APIRequestBody<'/api/v4/ask-x'>;

export const sendInquiry = (payload: AskXInquiryPayload) =>
  post<void>('/v4/ask-x', payload);
